import { BATHYMETRYCHECKED } from "../../actions/portal";

export default function(state = false, action) {
  switch (action.type) {
    case BATHYMETRYCHECKED:
      return action.payload;
    default:
  }
  return state;
}
